<template>
  <div class="monitor">
    <!--    <div class="monitor_head">
      <div class="title">{{ projectName }}</div>
      <div class="btn" v-if="selectControl!=0" @click="fnPlayBack">查看回放</div>
      <div class="btn" v-else @click="fnBackLive">返回</div>
    </div> -->
    <!-- 1宫格 -->
    <div class="monitor_live one" v-if="selectControl==1 && !iframeSrc">

      <div v-for="(item,index) in nineList" :key="index" @mousemove="onEnterTd(index)" @mouseleave="onLeaveTd(index)">

        <transition name="el-fade-in-linear">
          <div class="control" style="background-image: linear-gradient(rgba(0,0,0,0),#000);bottom: 0px;top: unset;"
            v-if="item.liveAddress||item.hdAddress" v-show="controlShowIndex == index">
            <div class="btn" style="width: 100%;height: 50px;justify-content: normal;margin-left: 10px;">
              {{item.projectName+'【'+item.deviceSerial+':'+item.channelNo+'-'+(item.name?item.name:'未命名')+'】'}}
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div class="control" v-if="item.liveAddress||item.hdAddress" v-show="controlShowIndex == index">
            <div class="btn" v-if="index !== ysyShowSet" @click="ysyShowSet = index">云台控制</div>
            <div class="btn" v-else @click="ysyShowSet = false">关闭云台</div>
            <div class="btn" @click="fnPlayBack(index)">查看回放</div>
            <div class="btn" v-if="item.quality==1" @click="fnChangeOneQuality('2')">标清</div>
            <div class="btn" v-if="item.quality==2" @click="fnChangeOneQuality('1')">高清</div>
          </div>
        </transition>

        <iframe :src="item.iframeSrc" v-if="item.iframeSrc" width="1920" height="1080" id="ysOpenDevice"
          allowfullscreen></iframe>

        <img v-else class="img" src="../assets/no.png" />

        <transition name="el-fade-in">
          <div class="control_list" v-show="index === ysyShowSet" style="top: 50px;left: 0px;position: fixed;">
            <div class="list_left">
              <div class="left_top">
                <div class="control_btn" :class="item.speed == 0 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(0)">
                  <span>慢</span>
                </div>
              </div>
              <div class="left_center">
                <div class="control_btn" :class="item.speed == 1 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(1)">
                  <span>适中</span>
                </div>
              </div>
              <div class="left_bottom">
                <div class="control_btn" :class="item.speed == 2 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(2)">
                  <span>快</span>
                </div>
              </div>
            </div>
            <div class="list_center">
              <div class="center_top">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 8, speed: item.speed })">
                  <span>🔍+</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 10, speed: item.speed })">
                  <span>近焦</span>
                </div>
              </div>
              <div class="center_center">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 9, speed: item.speed })">
                  <span>🔍-</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 11, speed: item.speed })">
                  <span>远焦</span>
                </div>
              </div>
              <div class="center_bottom">
                <div class="control_btn">(空)</div>
              </div>
            </div>
            <div class="list_right">
              <div class="right_top">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 4, speed: item.speed })">
                  <span>↖</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 0, speed: item.speed })">
                  <span>↑</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 6, speed: item.speed })">
                  <span>↗</span>
                </div>
              </div>
              <div class="right_center">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 2, speed: item.speed })">
                  <span>←</span>
                </div>
                <div class="control_btn">(空)</div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 3, speed: item.speed })">
                  <span>→</span>
                </div>
              </div>
              <div class="right_bottom">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 5, speed: item.speed })">
                  <span>↙</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 1, speed: item.speed })">
                  <span>↓</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 7, speed: item.speed })">
                  <span>↘</span>
                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>
    </div>


    <div class="monitor_live" :class="selectControl==4 ? 'four' : 'nine'" v-else-if="!iframeSrc">
      <div class="list_box" v-for="(item,index) in nineList" :key="index" @mousemove="onEnterTd(index)"
        @mouseleave="onLeaveTd(index)">

        <transition name="el-fade-in-linear">
          <div class="control" style="background-image: linear-gradient(rgba(0,0,0,0),#000);bottom: 0px;top: unset;"
            v-if="item.liveAddress||item.hdAddress" v-show="controlShowIndex != index">
            <div class="btn" style="width: 100%;height: 50px;justify-content: normal;margin-left: 10px;">
              {{item.projectName+'【'+item.deviceSerial+':'+item.channelNo+'-'+(item.name?item.name:'未命名')+'】'}}
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div class="control" v-if="item.liveAddress||item.hdAddress" v-show="controlShowIndex == index">
            <div class="btn" v-if="index !== ysyShowSet" @click="ysyShowSet = index">云台控制</div>
            <div class="btn" v-else @click="ysyShowSet = false">关闭云台</div>
            <div class="btn" @click="fnPlayBack(index)">查看回放</div>
            <div class="btn" v-if="item.quality==1" @click="fnChangeNineQuality(index,'2')">标清</div>
            <div class="btn" v-if="item.quality==2" @click="fnChangeNineQuality(index,'1')">高清</div>
          </div>
        </transition>

        <video class="video" v-if="item.liveAddress||item.hdAddress" :id="'player_nine'+index"
          :ref="'player_nine'+index" :src="item.quality == 1 ? item.liveAddress : item.hdAddress" controls playsInline
          webkit-playsinline></video>
        <img class="img" v-else src="../assets/no.png" />

        <transition name="el-fade-in">
          <div class="control_list" v-show="index === ysyShowSet"
            :style="index >= (selectControl==4 ? 2 : 12) ?  (selectControl==4 ? 'top:-666px' : 'top:-395px'):''">
            <div class="list_left">
              <div class="left_top">
                <div class="control_btn" :class="item.speed == 0 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(0)">
                  <span>慢</span>
                </div>
              </div>
              <div class="left_center">
                <div class="control_btn" :class="item.speed == 1 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(1)">
                  <span>适中</span>
                </div>
              </div>
              <div class="left_bottom">
                <div class="control_btn" :class="item.speed == 2 ? 'yellow' : 'blue'" @click="fnSelectOneSpeed(2)">
                  <span>快</span>
                </div>
              </div>
            </div>
            <div class="list_center">
              <div class="center_top">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 8, speed: item.speed })">
                  <span>🔍+</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 10, speed: item.speed })">
                  <span>近焦</span>
                </div>
              </div>
              <div class="center_center">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 9, speed: item.speed })">
                  <span>🔍-</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 11, speed: item.speed })">
                  <span>远焦</span>
                </div>
              </div>
              <div class="center_bottom">
                <div class="control_btn">(空)</div>
              </div>
            </div>
            <div class="list_right">
              <div class="right_top">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 4, speed: item.speed })">
                  <span>↖</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 0, speed: item.speed })">
                  <span>↑</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 6, speed: item.speed })">
                  <span>↗</span>
                </div>
              </div>
              <div class="right_center">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 2, speed: item.speed })">
                  <span>←</span>
                </div>
                <div class="control_btn">(空)</div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 3, speed: item.speed })">
                  <span>→</span>
                </div>
              </div>
              <div class="right_bottom">
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 5, speed: item.speed })">
                  <span>↙</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 1, speed: item.speed })">
                  <span>↓</span>
                </div>
                <div class="control_btn blue"
                  @click="fnControl({ deviceSerial: item.deviceSerial, channelNo: item.channelNo, direction: 7, speed: item.speed })">
                  <span>↘</span>
                </div>
              </div>
            </div>
          </div>
        </transition>


      </div>
    </div>
    <div class="monitor_live iframe" v-else>
      <div @click="fnBackLive"
        style="position: absolute;text-align: center;width: 100%;line-height: 53px;color: #ffff;font-size: 14px;cursor: pointer;">
        关闭回放
      </div>
      <iframe :src="iframeSrc" v-if="iframeSrc" width="1920" height="1080" id="ysOpenDevice" allowfullscreen></iframe>
    </div>
    <!-- 左侧边栏 -->
    <div class="monitor_left" :class="isLeftOpen?'open':'close'" v-if="selectControl!=0">
      <div class="close_btn" v-if="isLeftOpen" @click="isLeftOpen = false">
        <img src="../assets/left.png" />
      </div>
      <div class="open_btn" v-else @click="isLeftOpen = true">
        <img src="../assets/right.png" />
      </div>
      <div class="top_list">
        <div class="list_title">视图控制</div>
        <div class="list_item">
          <div class="list_check" @click="fnShowLive(1)">
            <div class="one" :class="selectControl==1?'active':''"></div>
            <div class="title">1宫格</div>
          </div>
          <div class="list_check" @click="fnShowLive(4)">
            <div class="four" :class="selectControl==4?'active':''"></div>
            <div class="title">4宫格</div>
          </div>
          <div class="list_check" @click="fnShowLive(16)">
            <div class="nine" :class="selectControl==16?'active':''"></div>
            <div class="title">16宫格</div>
          </div>
        </div>
      </div>
      <div class="top_list">
        <div class="list_title">自动轮播时间</div>
        <div class="list_item" style="margin: 5px;">
          <el-input v-model="carouselTime" placeholder="输入0为关闭轮播" @change="fnCarouselTime"></el-input>
          <div style="margin-left: 5px;color: #fff;font-size: 12px;">分钟</div>
        </div>
      </div>
      <div class="bottom_list">
        <div class="bottom_box">
          <div class="list_title">通道列表</div>
          <div class="list_box" :class="item.selected?'active':''" v-for="(item,index) in leftList" :key="index"
            @click="fnChooseChannel(item,index)">
            <i class="el-icon-check yes" v-if="item.selected"></i>
            <div class="box_title">{{ index+1 }}.{{ item.name?item.name:'未命名' }}</div>
            <div class="box_img">
              <img :src="item.cover" v-if="item.cover">
              <img src="../assets/nos.png" v-else>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog_playback" v-if="isChooseTime">
      <el-dialog :modal="false" title="选择回放时间" :visible.sync="isChooseTime" center>
        <el-date-picker size="small" v-model="chooseTime" type="datetimerange" value-format="yyyyMMddHHmmss"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <div slot="footer" class="dialog-footer">
          <div class="btn_line">
            <div class="search_btn" @click="isChooseTime = false"><span>取消</span></div>
            <div class="search_btn blue" @click="fnSureTime"><span>确定</span></div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import EZUIKit from '../../static/ezuikit.js'
  import Data from '../util/json.js'

  export default {
    data() {
      return {
        projectId: null,
        isChooseTime: false, // 查看回放时间
        chooseTime: "", // 选择的回放时间
        nowTime: "", // 选择回放时间时的时间戳
        maxTime: "", // 选择回放时间较大时间的时间戳
        pickerOptions: {
          onPick: ({
            maxDate,
            minDate
          }) => {
            let _max = new Date(maxDate).getTime()
            let _now = new Date(this.fnGetDateFormat()).getTime()
            this.nowTime = _now
            this.maxTime = _max
            if (maxDate && (_max > _now)) {
              this.chooseTime = "";
              this.$message.warning("选择回放的结束时间不能超过当前时间!")
            }
          }
        },
        isLeftOpen: false, // 左侧侧边栏是否打开
        liveList: [], // 直播列表数据
        leftList: [], // 侧边栏列表数据
        iframeSrc: "", // iframe 的 src
        nineList: [], // 9宫格直播列表
        nineSelect: null, // 选择的 9 宫格 通道
        player_nine: [], // 萤石云初始化 9 宫格
        oldSelectControl: null, // 回放前选择的宫格
        selectControl: 4, // 选择宫格
        selectChannel: null, // 选择的单个回放的通道号
        controlShowIndex: null,
        ysyShowSet: false,
        moveTimeout: null,
        carouselTime: 10,
        carouselInterval: null,
        waitingTimeout: null,
      }
    },
    mounted() {
      this.fnInit()
      this.fnCarousel()
      this.fnRefresh()
    },
    methods: {
      fnRefresh() {
        setInterval(() => {
          if (this.selectControl == 1) {
            return
          }
          for (let i in this.player_nine) {
            let video = this.$refs['player_nine' + i][0]
            if (video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2) {
              console.log(i + '正在播放');
            } else {
              console.error(i + '未播放')
              this.fnPlay(this.nineList)
              return
            }
          }
        }, 10 * 1000)
      },
      fnCarouselTime(e) {
        clearInterval(this.carouselInterval)
        if (e == 0) return
        this.fnCarousel()
      },
      fnCarousel() {
        this.carouselInterval = setInterval(() => {
          let _list = JSON.parse(JSON.stringify(this.liveList))

          if (this.selectControl >= _list.length) return

          this.leftList = _list

          // 获取正在播放的最后一路在列表内的index
          let last_index = null
          let last = this.nineList[this.nineList.length - 1]

          for (let i in _list) {
            if (_list[i].deviceSerial == last.deviceSerial && _list[i].channelNo == last.channelNo) {
              last_index = i
            }
          }

          let new_list = _list
          last_index = parseInt(last_index) + 1
          if (last_index < _list.length) {
            let front = _list.slice(0, last_index)
            let after = _list.slice(last_index)
            new_list = after.concat(front);
          }

          let arr = []
          for (let i in new_list) {
            if (i >= this.selectControl) break
            arr.push(new_list[i])
          }

          this.fnPlay(arr)

          for (let i in _list) {
            _list[i].selected = false

            for (let index in arr) {
              if (_list[i].deviceSerial == arr[index].deviceSerial && _list[i].channelNo == arr[index].channelNo) {
                _list[i].selected = true
                break
              }
            }
          }

        }, this.carouselTime * 60 * 1000)
      },
      // 初始化
      fnInit() {
        let that = this
        that.projectId = that.$route.params.id
        that.$axios.get('http://zgj-api.v2.cqzgzl.com/zgj-monitor/getLargeScreenList?type=' + that.projectId)
          .then(function(res) {
            let _data = res.data
            if (_data.code != 1) return;

            let _arr = _data.data

            for (let i in _arr) {
              let _index1 = _arr[i].liveAddress.lastIndexOf(':')
              _arr[i].liveAddress = 'https' + _arr[i].liveAddress.slice(_index1)
              let _index2 = _arr[i].hdAddress.lastIndexOf(':')
              _arr[i].hdAddress = 'https' + _arr[i].hdAddress.slice(_index2)
              _arr[i].quality = '1'
              _arr[i].selected = false
            }
            console.log(_arr);
            that.liveList = _arr
            that.fnShowLive(1)
          })
          .catch(function(err) {
            console.log(err);
          });
      },

      onEnterTd(e) {
        this.controlShowIndex = e

        if (this.moveTimeout) {
          clearTimeout(this.moveTimeout)
          this.moveTimeout = null
        }

        this.moveTimeout = setTimeout(() => {
          this.controlShowIndex = null
          this.moveTimeout = null
        }, 5000)
      },
      onLeaveTd(e) {
        this.controlShowIndex = null
      },

      // 根据选择的宫格 初始化直播
      fnShowLive(control) {
        this.selectControl = control
        let _list = JSON.parse(JSON.stringify(this.liveList))
        this.leftList = _list
        let arr = []
        for (let i in _list) {
          if (i < control) {
            _list[i].selected = true
            arr.push(_list[i])
          } else {
            _list[i].selected = false
          }
        }

        this.fnPlay(arr)
      },

      fnPlay(arr) {
        console.log('-------fnPlay------', arr);
        if (arr.length < this.selectControl) {
          let p = this.selectControl - arr.length
          for (let i = 0; i < p; i++) {
            arr.push({
              "cover": "../assets/no.png"
            })
          }
        }

        this.nineList = arr
        console.log(this.nineList);

        this.$nextTick(() => {
          for (let i in this.nineList) {
            if (!this.nineList[i].liveAddress) continue;

            if (this.selectControl == 1) {
              this.nineList[i].iframeSrc = this.fnGetOneLive(this.nineList[i], 1)
              return
            }

            let _id = 'player_nine' + i
            this.player_nine[i] = new EZUIKit.EZUIPlayer(_id);
            this.player_nine[i].play();

            // let ref = this.$refs[_id][0]
            // console.log('------ref---', ref);
            // ref.addEventListener('waiting', this.fnWaiting);
          }
        })
      },

      // fnWaiting(_i) {
      //   console.log('-------fnWaiting------', _i.target.id);

      //   if (this.waitingTimeout !== null) {
      //     clearTimeout(this.waitingTimeout)
      //   }

      //   this.waitingTimeout = setTimeout(() => {
      //     console.log('-------fnWaiting------执行');
      //     this.fnPlay(this.nineList)
      //   }, 1000)
      // },

      fnGetOneLive(_i, _quality) {
        return "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/" + _i.deviceSerial + "/" + _i
          .channelNo + (_quality == 1 ? '' : '.hd') +
          ".live&autoplay=1&accessToken=" + _i.accessToken
      },

      // 暂停直播画面
      fnStopLive() {
        for (let i in this.player_nine) {
          console.log(this.player_nine[i]);
          let aa = this.player_nine[i].stop();
          console.log(aa);
        }
        this.player_nine = [];
      },
      fnChangeOneQuality(quality) {
        this.nineList[0].quality = quality
        this.nineList[0].iframeSrc = this.fnGetOneLive(this.nineList[0], quality)
      },
      // 切换9宫格直播高清 标清
      fnChangeNineQuality(index, quality) {
        this.nineList[index].quality = quality
        this.$nextTick(() => {
          this.player_nine[index] = new EZUIKit.EZUIPlayer('player_nine' + index)
          this.player_nine[index].play()
        })
      },
      // 判断页面是显示的全部直播还是单个回放
      fnPlayBack(i) {
        let _obj = {}

        _obj = this.nineList[i]

        if (_obj.liveAddress) {
          this.isChooseTime = true
          this.chooseTime = ""
          this.selectChannel = _obj
        } else {
          this.$message.warning("请选择正确的通道！")
        }
      },
      // 选择侧边栏通道
      fnChooseChannel(item, index) {
        console.log(item, index);
        this.selectControl = 1

        for (let i in this.leftList) {
          this.leftList[i].selected = false
        }
        this.leftList[index].selected = true

        let arr = []
        item.iframeSrc = this.fnGetOneLive(item, 1)
        arr.push(item)
        this.nineList = arr
      },
      // 返回直播
      fnBackLive() {
        this.iframeSrc = ''
        this.selectControl = JSON.parse(JSON.stringify(this.oldSelectControl))
        this.oldSelectControl = null
        this.$nextTick(() => {
          for (let i in this.nineList) {
            if (this.nineList[i].liveAddress) {
              let _id = 'player_nine' + i
              this.player_nine[_id] = new EZUIKit.EZUIPlayer(_id);
              this.player_nine[_id].play();
            }
          }
        })
      },
      // 确定选择时间 -> 回放页面
      fnSureTime() {
        if (this.chooseTime && this.chooseTime.length == 2) {
          if (this.maxTime > this.nowTime) return this.$message.warning("选择回放的结束时间不能超过当前时间!")
          if (this.players) {
            this.players.stop()
          }
          this.oldSelectControl = JSON.parse(JSON.stringify(this.selectControl))
          this.isChooseTime = false
          this.selectControl = 0
          let url = "https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://open.ys7.com/" + this.selectChannel
            .deviceSerial + "/" + this.selectChannel.channelNo + ".rec&autoplay=1&accessToken=" + this.selectChannel
            .accessToken +
            "&begin=" + this.chooseTime[0] + "&end=" + this.chooseTime[1]
          this.iframeSrc = url
        }
      },
      // 格式化时间戳 时间戳
      fnGetDateFormat() {
        let _myDate = new Date()
        let _year = _myDate.getFullYear()
        let _month = this.fnAddZero_public(_myDate.getMonth() + 1)
        let _day = this.fnAddZero_public(_myDate.getDate())
        let _hour = this.fnAddZero_public(_myDate.getHours())
        let _min = this.fnAddZero_public(_myDate.getMinutes())
        let _sec = this.fnAddZero_public(_myDate.getSeconds())
        return _year + '-' + _month + '-' + _day + ' ' + _hour + ':' + _min + ':' + _sec
      },
      // 少于10补零
      fnAddZero_public(_num) {
        return _num < 10 ? '0' + _num : _num
      },
      // 控制设备
      fnControl(_data) {
        this.fnStartControl(_data);
        setTimeout(() => {
          this.fnStopControl(_data);
        }, 500);
      },
      // 开始控制
      fnStartControl(_data) {
        let _obj = {
          state: 'start',
          deviceSerial: _data.deviceSerial,
          channelNo: _data.channelNo,
          direction: _data.direction,
          speed: _data.speed
        };
        this.fnControlMonitor(_obj);
      },
      // 结束控制
      fnStopControl(_data) {
        let _obj = {
          state: 'stop',
          deviceSerial: _data.deviceSerial,
          channelNo: _data.channelNo,
          direction: _data.direction,
          speed: _data.speed
        };
        this.fnControlMonitor(_obj);
      },
      // 设备控制公共方法
      fnControlMonitor(_obj) {
        let that = this
        this.$axios.post('https://zgj-api.cqzgzl.com/monitor/control_ysy', _obj)
          .then(function(res) {
            console.log(res);
            if (res.data.code != 1) {
              that.$message.error(res.data.data);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/styles/mixin.scss';

  body::-webkit-scrollbar {
    display: none;
  }

  .control_list {
    width: 270px;
    height: 115px;
    padding: 5px;
    position: relative;
    z-index: 3;
    top: -4px;
    left: 195px;
    border-radius: 5px;
    background-color: #091120;
    @include flex-box(flex-start);

    .list_left {
      width: 40px;
      height: 105px;
      @include flex-box(flex-start, center, column, wrap);

      .left_top,
      .left_center,
      .left_bottom {
        width: 40px;
        height: 35px;
        @include flex-box(center, center);
      }
    }

    .list_center {
      width: 90px;
      height: 105px;
      @include flex-box(flex-start, center, column, wrap);

      .center_top,
      .center_center,
      .center_bottom {
        width: 90px;
        height: 35px;
        @include flex-box(space-around, center);
      }
    }

    .list_right {
      width: 130px;
      height: 105px;
      @include flex-box(flex-start, center, column, wrap);

      .right_top,
      .right_center,
      .right_bottom {
        width: 130px;
        height: 35px;
        @include flex-box(space-between, center);
      }
    }

    .control_btn {
      width: 40px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      color: #ffffff;
      border: none;
      cursor: pointer;
      @include flex-box(center, center);

      &.blue {
        background: url(../assets/btn_bg_bsm.png) no-repeat;
        background-size: 100% 100%;
      }

      &.yellow {
        background: url(../assets/btn_bg_osm.png) no-repeat;
        background-size: 100% 100%;
      }

      &.big {
        width: 90px;
      }

      &.f-20 {
        font-size: 20px;
      }

      span {
        margin-top: -2px;
      }
    }
  }

  .monitor {
    overflow: hidden;
    position: relative;

    .monitor_head {
      width: 100%;
      height: 35px;
      line-height: 35px;
      font-size: 16px;
      font-family: "宋体";
      color: #FFFFFF;
      border-bottom: 2px solid #C0C4CC;
      @include flex-box(space-between, center);

      .title {
        margin-left: 20px;
      }

      .btn {
        width: 84px;
        height: 28px;
        border-radius: 8px;
        background-color: #C0C4CC;
        color: #1C2357;
        margin-right: 20px;
        cursor: pointer;
        @include flex-box(center, center);
      }
    }

    .monitor_live {
      width: 1920px;
      height: 1080px;
      margin: 0 auto;
      position: relative;
      overflow: hidden;

      .control {
        position: absolute;
        color: #FFFFFF;
        top: 0;
        right: 0;
        z-index: 10;
        cursor: pointer;
        width: 100%;
        height: 50px;
        font-size: 14px;
        background-image: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
        @include flex-box(space-between, flex-start);

        .btn {
          width: 100px;
          height: 35px;
          cursor: pointer;
          @include flex-box(center, center);
        }
      }

      &.one {
        height: 1080px;
        background-color: rgba(51, 51, 51, 1);

        video {
          width: 1920px;
          height: 1080px;
        }

        img {
          width: 1920px;
          height: 1080px;
        }
      }

      &.four {
        height: 1080px;
        @include flex-box(space-between, flex-start, row, wrap);

        .list_box {
          width: 956px;
          height: 536px;
          border: 2px solid #C0C4CC;
          background-color: rgba(51, 51, 51, 1);
          position: relative;

          // &:nth-child(1),
          // &:nth-child(2) {
          //   margin-bottom: 5px;
          // }

          // &.active {
          //   border: 2px solid #FFA500;
          // }

          .video {
            width: 100%;
            height: 100%;
          }

          .img {
            width: 100%;
            height: 100%;
          }
        }
      }

      &.nine {
        height: 1080px;
        // padding:  2px;
        @include flex-box(space-between, flex-start, row, wrap);

        .list_box {
          width: 476px;
          height: 266px;

          border: 2px solid #C0C4CC;
          background-color: rgba(51, 51, 51, 1);
          position: relative;

          // &:nth-child(1),
          // &:nth-child(2),
          // &:nth-child(3),
          // &:nth-child(4),
          // &:nth-child(5),
          // &:nth-child(6) {
          //   margin-bottom: 5px;
          // }

          // &.active {
          //   border: 2px solid #FFA500;
          // }

          .video {
            width: 100%;
            height: 100%;
          }

          .img {
            width: 100%;
            height: 100%;
          }


        }
      }

      &.iframe {
        height: 1080px;
        border: none;
      }
    }

    .monitor_left {
      z-index: 9999;
      width: 245px;
      height: 1042px;
      position: absolute;
      background-color: #1C2357;
      left: 0;
      top: 22px;

      &.close {
        left: -249px;
        transition: left 0.5s;
      }

      &.open {
        left: 10px;
        transition: left 0.5s;
      }

      .open_btn,
      .close_btn {
        width: 50px;
        height: 60px;
        position: absolute;
        font-weight: bold;
        top: 430px;
        right: -50px;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.3);
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        @include flex-box(center, center);

        img {
          width: 40px;
        }
      }

      .top_list {
        width: 241px;
        height: 120px;
        border: 2px solid #C0C4CC;
        @include flex-box(flex-start, flex-start, cloumn, wrap);

        .list_title {
          width: 241px;
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          color: #FFFFFF;
          background-color: rgba(255, 255, 255, 0.2);
          box-shadow: 0 0 12px rgba(0, 0, 0, 0.16);
          padding-left: 15px;
        }

        .list_item {
          width: 241px;
          height: 80px;
          @include flex-box(space-around, center);

          .list_check {
            width: 60px;
            height: 70px;
            margin-top: 10px;
            @include flex-box(center, center, cloumn, wrap);

            .one {
              width: 40px;
              height: 40px;
              background: url(../assets/one.png) no-repeat;
              background-size: 100% 100%;

              &.active {
                background: url(../assets/one_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }

            .four {
              width: 40px;
              height: 40px;
              background: url(../assets/four.png) no-repeat;
              background-size: 100% 100%;

              &.active {
                background: url(../assets/four_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }

            .nine {
              width: 40px;
              height: 40px;
              background: url(../assets/nine.png) no-repeat;
              background-size: 100% 100%;

              &.active {
                background: url(../assets/nine_select.png) no-repeat;
                background-size: 100% 100%;
              }
            }

            .title {
              width: 60px;
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 12px;
              color: #FFFFFF;
            }
          }
        }
      }

      .bottom_list {
        width: 241px;
        height: 781px;
        margin-top: 10px;
        border: 2px solid #C0C4CC;
        position: relative;
        overflow: hidden;

        .bottom_box {
          position: absolute;
          left: 0;
          right: -20px;
          top: 0;
          bottom: 0;
          overflow-x: hidden;
          overflow-y: auto;
          @include flex-box(flex-start, flex-start, column);

          .list_title {
            width: 241px;
            height: 40px;
            line-height: 40px;
            font-size: 18px;
            color: #FFFFFF;
            background-color: rgba(255, 255, 255, 0.2);
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.16);
            padding-left: 15px;
          }

          .list_box {
            margin: 10px 11px 0;
            width: 216px;
            height: 146px;
            border: 2px solid rgba(255, 255, 255, 0.5);
            position: relative;

            &.active {
              border: 2px solid #FFA500;

              .yes {
                position: absolute;
                bottom: 0;
                right: 0;
                width: 30px;
                height: 30px;
                font-size: 26px;
                color: #FFA500;
              }
            }

            .box_title {
              width: 206px;
              padding-left: 10px;
              height: 30px;
              line-height: 30px;
              position: absolute;
              top: 0;
              left: 0;
              color: #FFFFFF;
              font-size: 16px;
              font-family: '宋体';
              background-color: rgba(0, 0, 0, 0.2);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .box_img {
              width: 216px;
              height: 146px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  .dialog_playback {
    >>>.el-dialog__body {
      text-align: center;
    }

    >>>.el-dialog {
      width: 460px;
      height: 210px;
      margin-top: 20vh !important;
      background-color: rgba(9, 17, 32, 1);
      border: 1px solid rgba(58, 116, 221, 1);
    }

    >>>.el-dialog__title {
      color: #4db4f4;
    }

    .btn_line {
      @include flex-box(center, center);

      .search_btn {
        width: 100px;
        height: 32px;
        margin: 0 3px;
        background: url(../assets/btn_bg_rsm.png) no-repeat;
        background-size: 100% 100%;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
        @include flex-box(center, center);

        span {
          margin-top: -5px;
        }

        &.blue {
          background: url(../assets/btn_bg_bsm.png) no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Monitor.vue